import { render, staticRenderFns } from "./XGenericFilter.vue?vue&type=template&id=fae2c868&"
import script from "./XGenericFilter.vue?vue&type=script&lang=js&"
export * from "./XGenericFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports